<script lang="ts">
    import { getContext, onDestroy, onMount } from 'svelte'
    import type { Writable } from 'svelte/store'

    import { WDATA } from 'hydria/context'
    import { gettext as _ } from 'hydria/services/gettext'
    import { altLanguages, setLg } from 'hydria/services/language'
    import { staticHashed } from 'hydria/static_hashed'
    import { asAny, spath } from 'hydria/svelte_helpers'
    import { alignToServer, DateTime, serverTimeDiffMs } from 'hydria/utils/time'

    import type { SubPage } from './signedout'

    import LostPassword from './LostPassword.svelte'
    import SetPassword from './SetPassword.svelte'
    import Signin from './Signin.svelte'

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    let ready = $state(false)

    const siContext = getContext('signed-in-context') as Writable<'unknown' | 'signed-in' | 'signed-out'>
    siContext.set('signed-out')

    const appElement = document.getElementById('app')
    onMount(() => {
        if (appElement) {
            appElement.classList.remove('loading-site')
            ready = true
        }
    })

    let serverYear = $state(DateTime.now().year)
    unsubs.push(
        serverTimeDiffMs.subscribe(() => {
            serverYear = alignToServer(DateTime.now()).year
        }),
    )

    let userRequestId: string | undefined = $state(undefined)
    if (window.location.pathname.startsWith(spath('/user-request/'))) {
        userRequestId = window.location.pathname.split('/user-request/')[1]
    }

    // svelte-ignore state_referenced_locally
    let subpage: SubPage = $state(userRequestId ? 'set-password' : 'signin')
    // let subpage: SubPage = WDATA['appmode'] === 'set-password' ? 'set-password' : 'signin'

    function goto(where: 'signin' | 'lost-password' | 'set-password') {
        subpage = where
    }
</script>

<style>
    #signin-form {
        height: 100vh;
        width: 100vw;
        overflow: auto;

        background-color: rgb(243, 243, 243);

        display: grid;
        grid-template-columns: minmax(375px, 560px);
        grid-template-rows: 1fr auto;
        grid-template-areas: 'frm' 'copy';
        justify-content: center;
    }
    #main-block {
        grid-area: frm;
        place-self: center;
    }
    #footer {
        grid-area: copy;
        color: white;
    }

    #main-block {
        /* width: 100%; */
        /* padding: 75px 75px 30px 75px; */
        padding: 75px 1rem 30px 1rem;

        display: grid;
        grid-template-columns: minmax(200px, 410px);
        grid-template-rows: auto auto auto;

        background: white;
        border-radius: 4px;
    }

    #main-block > :global(.logo) {
        justify-self: center;
        margin-bottom: 50px;
    }
    #main-block > :global(.section-title) {
        color: #3e4b5d;
        font-weight: 300;
        font-size: 20px;
        margin-bottom: 20px;
        border-bottom: 1px solid #e5e5e5;
    }

    #main-block > :global(.lang) {
        margin: 20px 0 10px 0;
        justify-self: center;
    }

    #main-block > :global(.property) {
        font-size: 12px;
        justify-self: center;
    }
    #main-block > :global(.property a + a) {
        margin-left: 2em;
    }

    #main-block :global(.extras) {
        text-align: center;
    }

    #main-block :global(.alert) {
        margin-bottom: 0 !important;
        padding: 6px 1em !important;
        text-align: center !important;
    }

    #main-block :global(form) {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }
    #main-block :global(input[type='text']),
    #main-block :global(input[type='email']),
    #main-block :global(input[type='password']) {
        height: 40px;
    }
    #main-block :global(.input-group) {
        width: 100%;
    }
    #main-block :global(.input-group-addon) {
        width: 40px;
    }
</style>

<div id="signin-form" class="signin-sub-{subpage}">
    {#if ready}
        <main id="main-block">
            <div class="logo"><a href={WDATA['public-site-url']}><img class="signin-logo img-responsive" src={staticHashed('static/img/signin-logo.svg')} alt="Administration" width="300" /></a></div>

            {#if subpage == 'signin'}
                <Signin goto={(e: any) => goto(e)} />
            {:else if subpage == 'lost-password'}
                <LostPassword goto={(e: any) => goto(e)} />
            {:else if subpage == 'set-password'}
                <SetPassword token={asAny(userRequestId)} goto={(e: any) => goto(e)} />
            {:else}
                <div>Showing block: {subpage}</div>
            {/if}

            <aside class="lang">
                {#each $altLanguages as altLg (altLg.lg)}
                    <a
                        href="/"
                        onclick={(e) => {
                            e.preventDefault()
                            setLg(altLg.lg)
                        }}><span>{altLg.text}</span></a
                    >
                {/each}
            </aside>
            <footer class="property">{@html $_('Propriété de <a href="{url}">A.R.C. Informatique Inc.</a>', { url: 'https://www.arcinformatique.ca/' })}</footer>
        </main>
    {/if}
    <footer id="footer" class="d-print-none">{$_('© {year} A.R.C. Informatique inc.', { year: serverYear })}</footer>
</div>
